import { Editor } from '@tiptap/core'
import StarterKit from '@tiptap/starter-kit'
import { Markdown } from 'tiptap-markdown'

export function markdownToHtml(markdown) {
    if (!markdown) {
        return ''
    }

    const editor = new Editor({
        extensions: [StarterKit, Markdown.configure({ html: false })],
        content: markdown,
    })
    const html = editor.getHTML()
    editor.destroy()

    return html
}
